<template>
    <v-app>
        <router-view />

        <generic-notification />

        <organization-basic-info-modal />

        <new-version-available-notification />
    </v-app>
</template>

<script>
import { defineComponent } from 'vue';
import genericNotification from './components/notifications/generic.vue';
import newVersionAvailableNotification from './components/notifications/newVersion.vue';
import OrganizationBasicInfoModal from './components/profile/basicInfoModal.vue';
import useSettings from './modules/settings.module';

export default defineComponent({
    components: { genericNotification, OrganizationBasicInfoModal, newVersionAvailableNotification },
    setup() {
        const { currentTheme } = useSettings();

        return { currentTheme };
    },
});
</script>

<style lang="scss">
.app-drawer .v-navigation-drawer__content {
    display: flex;
    flex-direction: column;
    height: 100%;
    min-height: 0;
}

.app-drawer .drawer-list {
    flex: 1 1 auto;
    min-height: 0;
    overflow-y: auto;
}

.app-drawer .drawer-append {
    flex: 0 0 auto;
    padding-bottom: calc(env(safe-area-inset-bottom, 0px) + 4px);
}

.delete-card-title {
    background-color: v-bind('currentTheme.error') !important;
}

.v-toolbar__extension {
    display: flex !important;
    justify-content: center;
}

.border-donations-order-product-type-class {
    border-bottom: 1px solid !important;
    border-top: 1px solid !important;
}

.v-card__title {
    word-break: break-word;
    background-color: v-bind('currentTheme.primary');
    color: white;
}

.v-data-table tbody tr:nth-child(odd) {
    background-color: v-bind('currentTheme.stripedOddRowBackground');
}

.v-application .v-btn--disabled,
.v-application .v-icon--disabled,
.v-application .v-input--switch.v-input--is-disabled * {
    cursor: not-allowed !important;
    pointer-events: auto;
}

.border-expansion-panel {
  border-bottom: 3px solid v-bind('currentTheme.primary');
}

.v-expansion-panel-header {
  font-weight: bold;
}

@media (max-width: 360px) {
    .v-expansion-panel-content__wrap {
        padding: 0 !important;
    }
}

.grecaptcha-badge {
    display: none;
}

.theme--light.v-small-dialog__actions, .theme--light.v-small-dialog__menu-content{
    max-width: 450px;
}

.theme--light.v-small-dialog__menu-content, .theme--light.v-small-dialog__actions {
    max-width: 450px;
}

// skeleton-loaders

.v-skeleton-loader__myCustomFilterButton {
    width: 230px;
    height: 60px;
    background: rgba(0, 0, 0, 0.12);
}

.v-skeleton-loader__myCustomText {
    height: 56px;
    background: rgba(0, 0, 0, 0.12);
}

/* Chrome, Safari, Edge, Opera */

.phone-number-input input::-webkit-outer-spin-button,
.phone-number-input input::-webkit-inner-spin-button,
.barcode-number-input input::-webkit-outer-spin-button,
.barcode-number-input input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
.phone-number-input input[type=number],
.barcode-number-input input[type=number]{
  -moz-appearance: textfield;
}

/* overwrite download file formats v-select */
.download-file-formats .v-text-field__details{
    display: none;
}
</style>
